package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_04_18_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Around midday, the heroes arrive at a shrine to Idril, Goddess of Nature and Love. A projection of Lalia appears, and she taunts the heroes, “aren’t you far from home?” Tuesday asks her about Umbraxus (the dragon that assaulted the heroes at sea), but she claims not to know about him. Lalia reiterates that the heroes collecting shards is good because demons and devils are at odds, but she also gives the heroes a warning:")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("The piece you seek might be a great challenge to you, equipped as you are. You might need to battle another group of adventurers, Drow. You may have never heard of them, but they are well-known in the subterranean lands. Their membership has changed over the years; you should expect 3-7 powerful adventurers. There could be a peaceful solution.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Elrovir tells the heroes that the Gideon forest is 1½ days away.")
    }
}
